import PropTypes from "prop-types"
import { Modal, Button, Flex } from "antd"
import { AlertIcon } from "ui/Icon/DSIcon/AlertIcon"
import styles from "./IncompleteDocumentsModal.module.css"

// Shown when a booking has unsigned required documents before check-in. The operator can
// cancel or override and check in anyway. Layout mirrors the Delete Note confirm modal:
// centered icon in a circular background, left-aligned title/subtitle/actions.
const IncompleteDocumentsModal = ({ open, onClose, description, loading = false, onOverride }) => (
  <Modal open={open} onCancel={onClose} footer={null} width={400} closable centered>
    <Flex vertical align="flex-start" gap={12} className={styles.body}>
      <div className={styles.icon}>
        <AlertIcon width={24} height={24} />
      </div>
      <Flex vertical gap={4}>
        <span className={styles.title}>Incomplete Waivers / Documents</span>
        <span className={styles.subtitle}>{description || "Guest has not completed the required documents."}</span>
      </Flex>
      <Flex gap={8} className={styles.actions}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button type="primary" onClick={onOverride} loading={loading}>
          Override &amp; Check-in
        </Button>
      </Flex>
    </Flex>
  </Modal>
)

IncompleteDocumentsModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  description: PropTypes.string,
  loading: PropTypes.bool,
  onOverride: PropTypes.func
}

export default IncompleteDocumentsModal
